import { render } from "./CloneSandboxJob.vue?vue&type=template&id=13b08b32"
import script from "./CloneSandboxJob.vue?vue&type=script&lang=js"
export * from "./CloneSandboxJob.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__